@if (isOpen) {
    <div
      class="copilot-panel"
      [class.copilot-panel--dragging]="isDragging"
      [class.copilot-panel--resizing]="isResizing"
      [style.left.px]="posX"
      [style.top.px]="posY"
      [style.width.px]="width"
      [style.height.px]="height"
      [attr.aria-label]="'Copilot' | translate">

      <header
        class="copilot-panel__header"
        (pointerdown)="onHeaderPointerDown($event)"
        (pointermove)="onHeaderPointerMove($event)"
        (pointerup)="onHeaderPointerUp()">
        <span class="copilot-panel__title">
          <mat-icon class="copilot-panel__title-icon" aria-hidden="true">auto_awesome</mat-icon>
          {{ 'Copilot' | translate }}
        </span>

        <div class="copilot-panel__header-actions">
          <button
            type="button"
            class="copilot-panel__icon-btn"
            [disabled]="!hasConversation"
            [matTooltip]="'NewChat' | translate"
            matTooltipPosition="below"
            [attr.aria-label]="'NewChat' | translate"
            (click)="startNewChat()">
            <app-icon name="document-edit" class="copilot-panel__icon-svg" aria-hidden="true" />
          </button>

          <button
            type="button"
            class="copilot-panel__icon-btn"
            [matTooltip]="'OpenAICounselor' | translate"
            matTooltipPosition="below"
            [attr.aria-label]="'OpenAICounselor' | translate"
            (click)="openFullPage()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M14 4H20V10M20 4L11 13M6 5H10M5 6V19H18V14"
                stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <button
            type="button"
            class="copilot-panel__icon-btn"
            [matTooltip]="'MinimizeCopilot' | translate"
            matTooltipPosition="below"
            [attr.aria-label]="'MinimizeCopilot' | translate"
            (click)="minimize()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </header>

      <div class="copilot-panel__body">
        @if (isChatbotBlocked) {
          <div class="copilot-panel__blocked">
            <button type="button" class="copilot-panel__blocked-message" (click)="goToChat()">
              {{ unavailableMessageKey | translate }}
            </button>
          </div>
        } @else if (view === 'welcome') {
          <div class="copilot-panel__welcome">
            <div class="copilot-panel__welcome-intro">
              <img class="copilot-panel__welcome-avatar" src="assets/images/icon-chat.svg" alt="" />

              <span class="copilot-panel__greeting">
                {{ greetingKey | translate }}{{ userName ? ', ' + userName : '' }} 👋
              </span>

              <h2 class="copilot-panel__heading">
                <span class="copilot-panel__heading-plain">{{ 'IAmYou' | translate }} </span>
                <strong class="copilot-panel__heading-accent">{{ 'AICounselor' | translate }}</strong>
                <span class="copilot-panel__heading-plain"> {{ letsFindKey | translate }}</span>
              </h2>
            </div>

            <div class="copilot-panel__chip-grid">
              <button type="button" class="copilot-panel__chip" (click)="onSuggestionSelected(suggestions[0])">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M2 10L12 3l10 7M4 10v10M20 10v10M8 10v10M16 10v10M2 20h20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ suggestions[0] }}
              </button>
              <button type="button" class="copilot-panel__chip" (click)="onSuggestionSelected(suggestions[1])">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 4L2 9l10 5 10-5-10-5Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6 11.5V16c0 1.4 2.7 2.8 6 2.8s6-1.4 6-2.8v-4.5M21 9v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ suggestions[1] }}
              </button>
              <button type="button" class="copilot-panel__chip" (click)="onSuggestionSelected(suggestions[2])">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 3v18M5 7h14M5 7l-3.2 6.2a3.2 3.2 0 0 0 6.4 0L5 7ZM19 7l-3.2 6.2a3.2 3.2 0 0 0 6.4 0L19 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ suggestions[2] }}
              </button>
              <button type="button" class="copilot-panel__chip" (click)="onSuggestionSelected(suggestions[3])">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M6 2h9l5 5v15H6z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15 2v5h5M9 13h6M9 17h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ suggestions[3] }}
              </button>
              <button type="button" class="copilot-panel__chip" (click)="onSuggestionSelected(suggestions[4])">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
                  <path d="M3 12h18M12 3c2.5 2.5 4 5.5 4 9s-1.5 6.5-4 9c-2.5-2.5-4-5.5-4-9s1.5-6.5 4-9Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ suggestions[4] }}
              </button>
            </div>

            <mindbase-chat-input
              [isSending]="isSending"
              [disabled]="isChatbotBlocked"
              [unavailableMessageKey]="unavailableMessageKey"
              (messageSent)="onSendMessage($event)">
            </mindbase-chat-input>
          </div>
        } @else {
          <mindbase-chat-window
            class="copilot-panel__chat-window"
            [view]="view"
            [messages]="messages"
            [userName]="userName"
            [isSending]="isSending"
            [disabled]="isChatbotBlocked"
            [hasMoreMessages]="false"
            [isLoadingMore]="false"
            (sendMessage)="onSendMessage($event)">
          </mindbase-chat-window>
        }
      </div>

      <div
        class="copilot-panel__resize-handle"
        (pointerdown)="onResizePointerDown($event)"
        (pointermove)="onResizePointerMove($event)"
        (pointerup)="onResizePointerUp()">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
          <path d="M1 9L9 1M4 9L9 4M7 9L9 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
        </svg>
      </div>
    </div>
}
